module.exports = __webpack_public_path__ + "assets/img/o4.ae02122a.png";